export default {
	medicineList: (state) => state.list,
	medicineHistory: (state) => state.history,
	medicinePending: (state) => state.pending,
	medicineStudent: (state) => state.filter.student,
	medicineDate: (state) => state.filter.date,
};



// WEBPACK FOOTER //
// ./sources/app/medicine/getters.js